export default __webpack_public_path__ + "static/media/muybridge-crop.ec2da358.jpg";